// extracted by mini-css-extract-plugin
export var button = "_c8-2";
export var iconWrapper = "_c8-0";
export var investigatingIcon = "_c8-1";